import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface PlayerBreakdown {
  playerId: string;
  name: string;
  total: number;
  present: number;
  late: number;
  absent: number;
  rate: number;
}

interface AttendanceTableProps {
  playerBreakdown: PlayerBreakdown[];
}

export function AttendanceTable({ playerBreakdown }: AttendanceTableProps) {
  if (playerBreakdown.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Player Attendance</CardTitle>
        <CardDescription>{playerBreakdown.length} players</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-left">
                <th className="pb-2 font-medium text-muted-foreground">Player</th>
                <th className="pb-2 font-medium text-muted-foreground text-center">Sessions</th>
                <th className="pb-2 font-medium text-muted-foreground text-center">Present</th>
                <th className="pb-2 font-medium text-muted-foreground text-center">Late</th>
                <th className="pb-2 font-medium text-muted-foreground text-center">Absent</th>
                <th className="pb-2 font-medium text-muted-foreground text-center">Rate</th>
              </tr>
            </thead>
            <tbody>
              {playerBreakdown.map(player => (
                <tr key={player.playerId} className="border-b last:border-0">
                  <td className="py-2.5 font-medium text-foreground">{player.name}</td>
                  <td className="py-2.5 text-center text-muted-foreground">{player.total}</td>
                  <td className="py-2.5 text-center text-green-600">{player.present}</td>
                  <td className="py-2.5 text-center text-yellow-600">{player.late}</td>
                  <td className="py-2.5 text-center text-red-600">{player.absent}</td>
                  <td className="py-2.5 text-center">
                    <Badge
                      className={cn(
                        'text-xs',
                        player.rate >= 80 ? 'bg-green-100 text-green-700' :
                        player.rate >= 50 ? 'bg-yellow-100 text-yellow-700' :
                        'bg-red-100 text-red-700'
                      )}
                    >
                      {player.rate}%
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
